import { defineStore } from 'pinia';
import { reactive } from 'vue';
import timeout from '~/utils/timeout';

export const useToastStore = defineStore('toastStore', () => {
  const toast = reactive({
    text: '',
    isShowing: false,
    timeout: 0,
  });

  const showToast = async (text: string) => {
    toast.text = text;

    if (toast.isShowing) {
      toast.isShowing = false;
      await timeout(100);
    }

    toast.isShowing = true;
    clearTimeout(toast.timeout);

    return new Promise<void>((resolve) => {
      toast.timeout = window.setTimeout(() => {
        toast.isShowing = false;
        resolve();
      }, 2500);
    });
  };

  const setExtraToastOffset = (value: number) => {
    document.body.style.setProperty('--extra-toast-offset', `${value}px`)
  }

  const removeExtraToastOffset = () => {
    document.body.style.removeProperty('--extra-toast-offset')
  }

  return {
    toast,
    showToast,
    setExtraToastOffset,
    removeExtraToastOffset,
  };
});
